// extracted by mini-css-extract-plugin
module.exports = {"root":"Resources_root__MxHhD","resourceList":"Resources_resourceList__rWp_J","title":"Resources_title__Oselj","address":"Resources_address__GJtQs"};